import { useState } from 'react';
import Store from '../store/Store';

interface LoginData {
  username: string;
  password: string;
  agree: boolean;
}

type InputChangeHandler = (value: string, id?: string) => void;
type CheckboxChangeHandler = (selected: boolean, id?: string) => void;

export function useLogin() {
  const [loginData, setLoginData] = useState<LoginData>({
    username: '',
    password: '',
    agree: false,
  });
  const loginError = Store.use('loginError');
  const [valid, setValid] = useState([true, true, true]);

  const onLogin = () => {
    const v = [!!loginData.username, !!loginData.password, loginData.agree];
    setValid(v);
    if (!v.includes(false)) Store.onLogin(loginData);
  };

  const onLoginIdAustria = () => {
    setValid([true, true, loginData.agree]);
    if (loginData.agree) {
      Store.navigate('loading');
      window.location.href = Store.config.api.url + 'id-austria-login';
    }
  };

  const handleInputChange: InputChangeHandler = (value, id) => {
    if (id && (id === 'username' || id === 'password')) {
      setLoginData(prev => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  const handleCheckboxChange: CheckboxChangeHandler = (selected, id) => {
    if (id === 'agree') {
      setLoginData(prev => ({
        ...prev,
        [id]: selected,
      }));
    }
  };

  return {
    loginData,
    valid,
    loginError: loginError ?? '',
    onLogin,
    onLoginIdAustria,
    handleInputChange,
    handleCheckboxChange,
  };
}
